module.exports = __webpack_public_path__ + "img/stickers_0013_medal.63a24b72.png";